// npm i react-blurhash
// npm i blurhash

import { LazyLoadImage } from 'react-lazy-load-image-component'
import styles from './Image.module.scss'

export const Image = ({ src, alt, blur, aspectRatio }) => {
  const containerStyle = {
    paddingTop: `${(aspectRatio[1] / aspectRatio[0]) * 100}%`,
  }

  return (
    <div className={styles.container} style={containerStyle}>
      <LazyLoadImage
        alt={alt}
        src={src}
        effect="blur"
        className={styles.container__image}
      />
    </div>
  )
}
